import React, { useContext } from 'react'

import UUID from 'uuid/v4'

import { makeStyles } from '@material-ui/core/styles'
import Pagination from '@material-ui/lab/Pagination'
import Skeleton from '@material-ui/lab/Skeleton'
import Context from '../../context'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px'
  },
  skeleton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  skeletonItem: {
    margin: '30px 10px'
  }
}))

function PaginationComponent() {
  const classes = useStyles()
  const { page, setPage, totalPages } = useContext(Context)

  const items = []

  for (let i = 0; i < totalPages; i++) {
    items.push(
      <Skeleton
        key={UUID()}
        className={classes.skeletonItem}
        variant="circle"
        width={30}
        height={30}
      />
    )
  }

  const handleChange = (event, value) => {
    setPage(value)
  }

  return (
    <>
      {page > 0 ? (
        <div className={classes.root}>
          <Pagination count={totalPages} page={page} onChange={handleChange} />
        </div>
      ) : (
        <div className={classes.skeleton}>{items}</div>
      )}
    </>
  )
}
export default PaginationComponent
